import { c as _c } from "react/compiler-runtime";
import { mergeClasses } from '@/utils/style';
import React from 'react';
import { FieldRenderProps } from 'react-final-form';
import { ErrorMessage } from '../ErrorMessage';
export function TextInput(props) {
  const $ = _c(39);
  const submitError = !props.meta.dirtySinceLastSubmit ? props.meta.submitError : undefined;
  const errorMessage = props.meta.error || submitError;
  const hasError = !!errorMessage && (props.meta.touched || props.meta.submitFailed);
  const errorId = `${props.input.name}-error`;
  let t0;
  if ($[0] !== props.className) {
    t0 = mergeClasses("relative", props.className);
    $[0] = props.className;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== props.leftIcon) {
    t1 = props.leftIcon && <span className="iconContainer absolute top-1/2 left-3 block h-6 w-6 -translate-y-1/2">{props.leftIcon}</span>;
    $[2] = props.leftIcon;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const t2 = props.input;
  let t3;
  if ($[4] !== props) {
    t3 = e => {
      props.input.onChange(e);
      props.onChange?.(e.target.value);
    };
    $[4] = props;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  const t4 = props.hideLabel ? props.label : "";
  const t5 = props.label;
  const t6 = hasError ? errorId : undefined;
  const t7 = hasError ? "true" : "false";
  const t8 = props.input.name;
  let t9;
  if ($[6] !== hasError || $[7] !== props.leftIcon || $[8] !== props.rightIcon) {
    t9 = mergeClasses("input", {
      "pr-3 pl-3": props.leftIcon || props.rightIcon
    }, {
      "pl-12": props.leftIcon
    }, {
      "pr-12": props.rightIcon
    }, {
      "border-red-500": hasError
    });
    $[6] = hasError;
    $[7] = props.leftIcon;
    $[8] = props.rightIcon;
    $[9] = t9;
  } else {
    t9 = $[9];
  }
  let t10;
  if ($[10] !== props.input || $[11] !== props.label || $[12] !== t3 || $[13] !== t4 || $[14] !== t6 || $[15] !== t7 || $[16] !== t9) {
    t10 = <input {...t2} onChange={t3} placeholder={t4} aria-label={t5} aria-describedby={t6} aria-invalid={t7} id={t8} className={t9} data-clarity-mask="true" />;
    $[10] = props.input;
    $[11] = props.label;
    $[12] = t3;
    $[13] = t4;
    $[14] = t6;
    $[15] = t7;
    $[16] = t9;
    $[17] = t10;
  } else {
    t10 = $[17];
  }
  const t11 = props.input.name;
  let t12;
  if ($[18] !== hasError || $[19] !== props.hideLabel || $[20] !== props.leftIcon) {
    t12 = mergeClasses("label", {
      "left-11 max-w-[calc(100%-4.75rem)]! min-w-0!": props.leftIcon
    }, {
      "text-red-500": hasError
    }, {
      hidden: props.hideLabel
    });
    $[18] = hasError;
    $[19] = props.hideLabel;
    $[20] = props.leftIcon;
    $[21] = t12;
  } else {
    t12 = $[21];
  }
  let t13;
  if ($[22] !== props.input.name || $[23] !== props.label || $[24] !== t12) {
    t13 = <label htmlFor={t11} className={t12}>{props.label}</label>;
    $[22] = props.input.name;
    $[23] = props.label;
    $[24] = t12;
    $[25] = t13;
  } else {
    t13 = $[25];
  }
  let t14;
  if ($[26] !== props.rightIcon) {
    t14 = props.rightIcon && <span className="iconContainer absolute top-1/2 right-3 block h-6 w-6 -translate-y-1/2">{props.rightIcon}</span>;
    $[26] = props.rightIcon;
    $[27] = t14;
  } else {
    t14 = $[27];
  }
  let t15;
  if ($[28] !== errorId || $[29] !== errorMessage || $[30] !== hasError) {
    t15 = hasError && <ErrorMessage error={errorMessage} id={errorId} />;
    $[28] = errorId;
    $[29] = errorMessage;
    $[30] = hasError;
    $[31] = t15;
  } else {
    t15 = $[31];
  }
  let t16;
  if ($[32] !== t0 || $[33] !== t1 || $[34] !== t10 || $[35] !== t13 || $[36] !== t14 || $[37] !== t15) {
    t16 = <div className={t0}>{t1}{t10}{t13}{t14}{t15}</div>;
    $[32] = t0;
    $[33] = t1;
    $[34] = t10;
    $[35] = t13;
    $[36] = t14;
    $[37] = t15;
    $[38] = t16;
  } else {
    t16 = $[38];
  }
  return t16;
}